import Modal from '@cp/src/components/Modal/Modal';
import React, { useState } from 'react';
import cx from 'classnames';
import { IconButtonSizes, IconButtonVariants } from '@navi/web-ui/lib/primitives/IconButton/types';
import { Card } from '@primitives';
import ImagePreviewIcon from '@cp/assets/icons/ImagePreviewIcon';
import eyeIcon from '@cp/assets/images/icons/eyeIcon.png';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { clickStreamConstants } from '@cp/pages/CaseDetails/components/AllDocumentsV2/clickStreamConstants';
import { useParams } from 'react-router-dom';

interface RenderImageProps {
  src: string;
  alt: string;
  className?: string;
  customModalHeaderClassName?: string;
  customModalContentClassName?: string;
  onClick?: () => void;
  onError?: () => void;
  iconButtonSize?: IconButtonSizes;
  iconButtonVariant?: IconButtonVariants;
  name: string;
}

const RenderImage: React.FC<RenderImageProps> = props => {
  const {
    src,
    alt,
    className,
    customModalHeaderClassName,
    customModalContentClassName,
    onClick,
    onError,
    iconButtonSize = 'small',
    iconButtonVariant = 'borderless-secondary',
    name = ''
  } = props;
  const { loanId = '', customerId = '' } = useParams();

  const ref = React.useRef<HTMLImageElement>(null);
  const [open, setOpen] = React.useState(false);
  const [isClickable, setIsClickable] = React.useState(false);
  const [isFocussed, setIsFocussed] = useState(false);
  const handleClose = () => setOpen(false);

  const handleClick = () => {
    if (!isClickable) return;
    addClickstreamEvent(clickStreamConstants.LH_DOCUMENT_VIEWED, {
      lan: loanId,
      document_name: name,
      document_type: 'image'
    });
    setOpen(true);
    onClick?.();
  };

  const handleImageError = () => {
    onError?.();
  };

  const handleClickable = () => {
    setIsClickable(true);
  };

  const handleOnFocus = () => {
    setIsFocussed(true);
  };

  const handleOnBlur = () => {
    setIsFocussed(false);
  };
  return (
    <>
      <Card className="cursor-pointer relative bg-[#FCFCFC] w-[247px]">
        <div className="p-0 card-header top-0 left-0  flex items-center gap-2 w-[247px]">
          <ImagePreviewIcon />
          <span className="text-[--Grayscale-Content-2] bold">{name}</span>
        </div>
        <div className="p-[16px] mt-16px flex relative">
          <img
            onMouseEnter={handleOnFocus}
            width={215}
            height={144}
            ref={ref}
            src={src}
            alt={alt}
            className={cx('object-contain', className)}
            onClick={handleClick}
            onError={handleImageError}
            onLoad={handleClickable}
          ></img>
          <div
            onClick={handleClick}
            onMouseOut={handleOnBlur}
            className={cx(
              'w-full h-full  absolute top-0 left-0 bg-black opacity-40 flex items-center justify-center rounded-md invisible',

              {
                '!visible': isFocussed
              }
            )}
          >
            <img src={eyeIcon} />
          </div>
        </div>
      </Card>
      <Modal
        visible={open}
        onClose={handleClose}
        headerClassName={cx('flex justify-between items-center !p-2', customModalHeaderClassName)}
        contentClassName={cx('!p-2 !pt-0', customModalContentClassName)}
        iconButtonSize={iconButtonSize}
        iconButtonVariant={iconButtonVariant}
        header={alt}
        headerColor="var(--grayscale-3)"
        closeOnOutsideClick
      >
        <img
          alt={'Image'}
          key={ref?.current?.src}
          src={ref?.current?.src}
          className="cursor-pointer max-w-[85vw] max-h-[80vh] object-contain"
        />
      </Modal>
    </>
  );
};

export default RenderImage;
